export default "__VITE_ASSET__epVghJpD__"